export default [
    {
        hidden: false,
        step: 1,
        name: 'StafetOpretHoldStepOne',
        label: 'formStepLabel1',
        completed: false
    },
    {
        hidden: true, // hidden - if true, the step will not be shown steps header
        step: 2, // order - manual number. The order of the array determins the steporder
        name: 'FormStepSubmitting', // stepname. Must correspond to a component declared under "components"
        label: 'submitErrorTitle',
        completed: false // are all fields valid?
    }
]
